import { OfflineScreen } from '@/features/offline-screen/offline-screen'
import { logCrumb, logMsg } from '@/shared/lib/sentry'
import { useEffect } from 'react'

interface AuthFallbackProps {
  onRetry: () => void
}

export default function AuthFallback({ onRetry }: AuthFallbackProps) {
  useEffect(() => {
    logCrumb({
      category: 'ui',
      level: 'info',
      message: 'AuthFallback mounted',
    })

    logMsg('User sees AuthFallback', 'info')
  }, [])

  const retry = () => {
    logCrumb({
      category: 'ui',
      level: 'info',
      message: 'OfflineScreen retry clicked',
    })
    logMsg('Retry from OfflineScreen', 'info')
    onRetry?.()
  }

  return <OfflineScreen retry={retry} />
}
